import {environment} from '../../environments/environment';
import * as amplitude from '@amplitude/analytics-browser';
import {Injectable} from '@angular/core';
import { WallboxService } from './wallbox.service';

@Injectable({
	providedIn: 'root'
})
export class AmplitudeService {
	private amplitudeApiKey = environment.amplitudeApiKey;
	private isEnableAmplitude = environment.amplitude;
	constructor(private wallboxService: WallboxService) {
	}

	private shouldTrackAmplitude() {
		const userCountry = this.wallboxService.getUserCountry();
		return this.isEnableAmplitude && !!userCountry && userCountry !== 'USA';
	}

	initialize() {
		amplitude.init(this.amplitudeApiKey, {
			defaultTracking: false
		});
	}

	setUserID(userId: string) {
		if (this.shouldTrackAmplitude()) {
			amplitude.setUserId(userId);
		}
	}

	sendEvents(event, eventProperties) {
		if (this.shouldTrackAmplitude()) {
			amplitude.track(event, eventProperties);
		}
	}
}

